export const NEWS_LOAD_REQUESTED = "NEWS_LOAD_REQUESTED";
export const NEWS_LOAD_SUCCEEDED = "NEWS_LOAD_SUCCEEDED";
export const NEWS_LOAD_FAILED = "NEWS_LOAD_FAILED";
export const NEWS_SAVE_REQUESTED = "NEWS_SAVE_REQUESTED";
export const NEWS_SAVE_SUCCEEDED = "NEWS_SAVE_SUCCEEDED";
export const NEWS_SAVE_FAILED = "NEWS_SAVE_FAILED";